<HomeNavBar />

<div class="container-fluid py-3 pb-extra px-2 px-sm-3 px-lg-4">
  <section class="card border shadow-sm rounded overflow-hidden mb-3 bg-light">
    <div class="card-body p-3">
      <div class="d-flex flex-column gap-3">
        <div class="d-flex flex-column flex-md-row align-items-md-center gap-2">
          <h4 class="fw-bold text-dark mb-0 fs-4">Marketplace Sales & Credit</h4>
        </div>

        <p class="text-muted mb-0 small ps-sm-0">
          Track marketplace sales, customer balances, unpaid credit orders, and settlements.
        </p>

        <div class="row g-2">
          <div class="col-6 col-md-auto">
            <button
              type="button"
              class="btn btn-sm rounded px-2 px-md-4 py-3 py-md-2 w-100 h-100 d-flex flex-column flex-md-row align-items-center justify-content-center text-center lh-sm"
              :class="active_dashboard_tab === 'sales' ? 'btn-primary' : 'btn-light border text-dark'"
              @click="active_dashboard_tab = 'sales'"
            >
              <span class="d-block d-md-inline">Sales</span>
              <span class="d-block d-md-inline ms-md-1">Management</span>
            </button>
          </div>
          <div class="col-6 col-md-auto">
            <button
              type="button"
              class="btn btn-sm rounded px-2 px-md-4 py-3 py-md-2 w-100 h-100 d-flex flex-column flex-md-row align-items-center justify-content-center text-center lh-sm"
              :class="active_dashboard_tab === 'credit' ? 'btn-primary' : 'btn-light border text-dark'"
              @click="active_dashboard_tab = 'credit'"
            >
              <span class="d-block d-md-inline">Credit</span>
              <span class="d-block d-md-inline ms-md-1">Management</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section v-if="active_dashboard_tab === 'sales'" class="card border shadow-sm rounded overflow-hidden mb-3 bg-light">
    <div class="card-body p-3 p-lg-4">
      <div class="d-flex flex-column gap-3">
        <div>
          <h6 class="fw-bold text-dark mb-1">Sales Filters</h6>
          <div class="text-muted small d-none d-sm-block">Refine sales results by period, payment type, delivery type, or customer.</div>
        </div>

        <div class="d-lg-none">
          <div class="row g-2">
            <div class="col-12">
              <div class="input-group rounded bg-light shadow-sm search-box w-100">
                <span class="input-group-text bg-light border-0">
                  <i class="bi bi-search text-muted"></i>
                </span>
                <input
                  v-model="sales_query"
                  type="text"
                  class="form-control bg-light border-0 shadow-none pe-2"
                  placeholder="Search customer or order number..."
                />
              </div>
            </div>

            <div class="col-12">
              <div class="text-muted text-uppercase small fw-semibold mb-1">Filter By</div>
              <select v-model="sales_mobile_filter_by" class="form-select bg-light border shadow-sm">
                <option value="month">Month</option>
                <option value="payment">Payment Type</option>
                <option value="delivery">Delivery Type</option>
              </select>
            </div>

            <div class="col-12">
              <div class="text-muted text-uppercase small fw-semibold mb-1">
                {{ sales_mobile_filter_by === 'month' ? 'Month' : sales_mobile_filter_by === 'payment' ? 'Payment Type' : 'Delivery Type' }}
              </div>
              <div v-if="sales_mobile_filter_by === 'month'" class="input-group rounded bg-light shadow-sm search-box w-100">
                <span class="input-group-text bg-light border-0">
                  <i class="bi bi-calendar3 text-muted"></i>
                </span>
                <select v-model="sales_selected_month" class="form-select bg-light border-0 shadow-none pe-2">
                  <option value="all">All Months</option>
                  <option v-for="option in month_options" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>

              <select
                v-else-if="sales_mobile_filter_by === 'payment'"
                v-model="sales_payment_filter"
                class="form-select bg-light border shadow-sm"
              >
                <option value="all">All Payments</option>
                <option value="paid">Paid</option>
                <option value="credit">Credit</option>
              </select>

              <select
                v-else
                v-model="sales_delivery_filter"
                class="form-select bg-light border shadow-sm"
              >
                <option value="all">All Delivery Types</option>
                <option value="collection">Collection</option>
                <option value="delivery">Delivery</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row g-2 d-none d-lg-flex">
          <div class="col-12 col-md-6 col-xl-4">
            <div class="input-group rounded bg-light shadow-sm search-box w-100">
              <span class="input-group-text bg-light border-0">
                <i class="bi bi-search text-muted"></i>
              </span>
              <input
                v-model="sales_query"
                type="text"
                class="form-control bg-light border-0 shadow-none pe-2"
                placeholder="Search customer or order number..."
              />
            </div>
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <div class="input-group rounded bg-light shadow-sm search-box w-100">
              <span class="input-group-text bg-light border-0">
                <i class="bi bi-calendar3 text-muted"></i>
              </span>
              <select v-model="sales_selected_month" class="form-select bg-light border-0 shadow-none pe-2">
                <option value="all">All Months</option>
                <option v-for="option in month_options" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-6 col-xl-2">
            <select v-model="sales_payment_filter" class="form-select bg-light border shadow-sm">
              <option value="all">All Payments</option>
              <option value="paid">Paid</option>
              <option value="credit">Credit</option>
            </select>
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <select v-model="sales_delivery_filter" class="form-select bg-light border shadow-sm">
              <option value="all">All Delivery Types</option>
              <option value="collection">Collection</option>
              <option value="delivery">Delivery</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section v-if="active_dashboard_tab === 'sales'" class="row g-2 g-lg-3 mb-4">
    <div class="col-6 col-xl-3">
      <div class="card border shadow-sm rounded p-3 h-100 bg-primary text-white d-lg-none">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-white d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-cash-stack"></i>
          </div>
          <div class="text-white small fw-semibold text-uppercase">Total Sales</div>
        </div>
        <div class="fs-5 fw-bold text-white mb-1">R{{ format_price(sales_stats.total_sales_amount) }}</div>
        <div class="text-white-50 small">{{ sales_stats.total_orders }} orders in {{ sales_active_month_label }}</div>
      </div>
      <div class="card border-1 border-primary shadow-sm rounded p-3 h-100 bg-light text-dark d-none d-lg-block">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-dark d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-cash-stack"></i>
          </div>
          <div class="text-muted small fw-semibold text-uppercase">Total Sales</div>
        </div>
        <div class="fs-5 fw-bold text-dark mb-1">R{{ format_price(sales_stats.total_sales_amount) }}</div>
        <div class="text-muted small">{{ sales_stats.total_orders }} orders in {{ sales_active_month_label }}</div>
      </div>
    </div>

    <div class="col-6 col-xl-3">
      <div class="card border shadow-sm rounded p-3 h-100 bg-primary text-white d-lg-none">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-white d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-check2-circle"></i>
          </div>
          <div class="text-white small fw-semibold text-uppercase">Paid Sales</div>
        </div>
        <div class="fs-5 fw-bold text-white mb-1">R{{ format_price(sales_stats.paid_sales_amount) }}</div>
        <div class="text-white-50 small">Completed and settled orders</div>
      </div>
      <div class="card border-1 border-primary shadow-sm rounded p-3 h-100 bg-light text-dark d-none d-lg-block">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-dark d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-check2-circle"></i>
          </div>
          <div class="text-muted small fw-semibold text-uppercase">Paid Sales</div>
        </div>
        <div class="fs-5 fw-bold text-dark mb-1">R{{ format_price(sales_stats.paid_sales_amount) }}</div>
        <div class="text-muted small">Completed and settled orders</div>
      </div>
    </div>

    <div class="col-6 col-xl-3">
      <div class="card border shadow-sm rounded p-3 h-100 bg-primary text-white d-lg-none">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-white d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-credit-card-2-front"></i>
          </div>
          <div class="text-white small fw-semibold text-uppercase">Unresolved Sales</div>
        </div>
        <div class="fs-5 fw-bold text-white mb-1">R{{ format_price(sales_stats.unresolved_sales_amount) }}</div>
        <div class="text-white-50 small">Sales not yet settled</div>
      </div>
      <div class="card border-1 border-primary shadow-sm rounded p-3 h-100 bg-light text-dark d-none d-lg-block">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-dark d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-credit-card-2-front"></i>
          </div>
          <div class="text-muted small fw-semibold text-uppercase">Unresolved Sales</div>
        </div>
        <div class="fs-5 fw-bold text-dark mb-1">R{{ format_price(sales_stats.unresolved_sales_amount) }}</div>
        <div class="text-muted small">Sales not yet settled</div>
      </div>
    </div>

    <div class="col-6 col-xl-3">
      <div class="card border shadow-sm rounded p-3 h-100 bg-primary text-white d-lg-none">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-white d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-graph-up-arrow"></i>
          </div>
          <div class="text-white small fw-semibold text-uppercase">Unresolved Orders Count</div>
        </div>
        <div class="fs-5 fw-bold text-white mb-1">{{ sales_stats.unpaid_orders_count }}</div>
        <div class="text-white-50 small">Orders not yet settled</div>
      </div>
      <div class="card border-1 border-primary shadow-sm rounded p-3 h-100 bg-light text-dark d-none d-lg-block">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-dark d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-graph-up-arrow"></i>
          </div>
          <div class="text-muted small fw-semibold text-uppercase">Unresolved Orders Count</div>
        </div>
        <div class="fs-5 fw-bold text-dark mb-1">{{ sales_stats.unpaid_orders_count }}</div>
        <div class="text-muted small">Orders not yet settled</div>
      </div>
    </div>
  </section>

  <section v-else-if="active_dashboard_tab === 'credit'" class="card border shadow-sm rounded overflow-hidden mb-3 bg-light">
    <div class="card-body p-3 p-lg-4">
      <div class="d-flex flex-column gap-3">
        <div>
          <h6 class="fw-bold text-dark mb-1">Credit Filters</h6>
          <div class="text-muted small d-none d-sm-block">Review credit customers and balances for the selected period.</div>
        </div>

        <div class="d-lg-none">
          <div class="row g-2">
            <div class="col-12">
              <div class="input-group rounded bg-light shadow-sm search-box w-100">
                <span class="input-group-text bg-light border-0">
                  <i class="bi bi-search text-muted"></i>
                </span>
                <input
                  v-model="customer_query"
                  type="text"
                  class="form-control bg-light border-0 shadow-none pe-2"
                  placeholder="Search customer or order number..."
                />
              </div>
            </div>

            <div class="col-12">
              <div class="text-muted text-uppercase small fw-semibold mb-1">Filter By</div>
              <select v-model="credit_mobile_filter_by" class="form-select bg-light border shadow-sm">
                <option value="month">Month</option>
                <option value="status">Credit Status</option>
              </select>
            </div>

            <div class="col-12">
              <div class="text-muted text-uppercase small fw-semibold mb-1">
                {{ credit_mobile_filter_by === 'month' ? 'Month' : 'Credit Status' }}
              </div>
              <div v-if="credit_mobile_filter_by === 'month'" class="input-group rounded bg-light shadow-sm search-box w-100">
                <span class="input-group-text bg-light border-0">
                  <i class="bi bi-calendar3 text-muted"></i>
                </span>
                <select v-model="credit_selected_month" class="form-select bg-light border-0 shadow-none pe-2">
                  <option value="all">All Months</option>
                  <option v-for="option in month_options" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>

              <select
                v-else
                v-model="credit_status_filter"
                class="form-select bg-light border shadow-sm"
              >
                <option value="all">All Credit Statuses</option>
                <option value="outstanding">Not Settled</option>
                <option value="settled">Settled</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row g-2 d-none d-lg-flex">
          <div class="col-12 col-md-6 col-xl-5">
            <div class="input-group rounded bg-light shadow-sm search-box w-100">
              <span class="input-group-text bg-light border-0">
                <i class="bi bi-search text-muted"></i>
              </span>
              <input
                v-model="customer_query"
                type="text"
                class="form-control bg-light border-0 shadow-none pe-2"
                placeholder="Search customer or order number..."
              />
            </div>
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <div class="input-group rounded bg-light shadow-sm search-box w-100">
              <span class="input-group-text bg-light border-0">
                <i class="bi bi-calendar3 text-muted"></i>
              </span>
              <select v-model="credit_selected_month" class="form-select bg-light border-0 shadow-none pe-2">
                <option value="all">All Months</option>
                <option v-for="option in month_options" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-6 col-xl-4">
            <select v-model="credit_status_filter" class="form-select bg-light border shadow-sm">
              <option value="all">All Credit Statuses</option>
              <option value="outstanding">Not Settled</option>
              <option value="settled">Settled</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section v-if="active_dashboard_tab === 'credit' && !selected_customer" class="row g-2 g-lg-3 mb-4">
    <div class="col-6 col-xl-3">
      <div class="card border shadow-sm rounded p-3 h-100 bg-primary text-white d-lg-none">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-white d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-people"></i>
          </div>
          <div class="text-white small fw-semibold text-uppercase lh-sm">
            <span class="d-block">Customers</span>
            <span class="d-block">On Credit</span>
          </div>
        </div>
        <div class="fs-5 fw-bold text-white mb-1">{{ credit_stats.customers_on_credit }}</div>
        <div class="text-white-50 small">Active in {{ active_month_label }}</div>
      </div>
      <div class="card border-1 border-primary shadow-sm rounded p-3 h-100 bg-light text-dark d-none d-lg-block">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-dark d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-people"></i>
          </div>
          <div class="text-muted small fw-semibold text-uppercase">Customers On Credit</div>
        </div>
        <div class="fs-5 fw-bold text-dark mb-1">{{ credit_stats.customers_on_credit }}</div>
        <div class="text-muted small">Active in {{ active_month_label }}</div>
      </div>
    </div>

    <div class="col-6 col-xl-3">
      <div class="card border shadow-sm rounded p-3 h-100 bg-primary text-white d-lg-none">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-white d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-exclamation-circle"></i>
          </div>
          <div class="text-white small fw-semibold text-uppercase lh-sm">
            <span class="d-block">Not Settled</span>
            <span class="d-block">Balance</span>
          </div>
        </div>
        <div class="fs-5 fw-bold text-white mb-1">R{{ format_price(credit_stats.outstanding_amount) }}</div>
        <div class="text-white-50 small">{{ credit_stats.outstanding_count }} not settled marketplace orders</div>
      </div>
      <div class="card border-1 border-primary shadow-sm rounded p-3 h-100 bg-light text-dark d-none d-lg-block">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-dark d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-exclamation-circle"></i>
          </div>
          <div class="text-muted small fw-semibold text-uppercase">Not Settled Balance</div>
        </div>
        <div class="fs-5 fw-bold text-dark mb-1">R{{ format_price(credit_stats.outstanding_amount) }}</div>
        <div class="text-muted small">{{ credit_stats.outstanding_count }} not settled marketplace orders</div>
      </div>
    </div>

    <div class="col-6 col-xl-3">
      <div class="card border shadow-sm rounded p-3 h-100 bg-primary text-white d-lg-none">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-white d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-check2-circle"></i>
          </div>
          <div class="text-white small fw-semibold text-uppercase lh-sm">
            <span class="d-block">Settled</span>
            <span class="d-block">Credit</span>
          </div>
        </div>
        <div class="fs-5 fw-bold text-white mb-1">R{{ format_price(credit_stats.paid_amount) }}</div>
        <div class="text-white-50 small">{{ credit_stats.paid_count }} settled orders</div>
      </div>
      <div class="card border-1 border-primary shadow-sm rounded p-3 h-100 bg-light text-dark d-none d-lg-block">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-dark d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-check2-circle"></i>
          </div>
          <div class="text-muted small fw-semibold text-uppercase">Settled Credit</div>
        </div>
        <div class="fs-5 fw-bold text-dark mb-1">R{{ format_price(credit_stats.paid_amount) }}</div>
        <div class="text-muted small">{{ credit_stats.paid_count }} settled orders</div>
      </div>
    </div>

    <div class="col-6 col-xl-3">
      <div class="card border shadow-sm rounded p-3 h-100 bg-primary text-white d-lg-none">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-white d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-receipt"></i>
          </div>
          <div class="text-white small fw-semibold text-uppercase lh-sm">
            <span class="d-block">Total Credit</span>
            <span class="d-block">Orders</span>
          </div>
        </div>
        <div class="fs-5 fw-bold text-white mb-1">{{ credit_stats.total_credit_orders }}</div>
        <div class="text-white-50 small">Captured in {{ active_month_label }}</div>
      </div>
      <div class="card border-1 border-primary shadow-sm rounded p-3 h-100 bg-light text-dark d-none d-lg-block">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="text-dark d-inline-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-receipt"></i>
          </div>
          <div class="text-muted small fw-semibold text-uppercase">Total Credit Orders</div>
        </div>
        <div class="fs-5 fw-bold text-dark mb-1">{{ credit_stats.total_credit_orders }}</div>
        <div class="text-muted small">Captured in {{ active_month_label }}</div>
      </div>
    </div>
  </section>

  <div v-if="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="mt-3 text-muted mb-0">Loading marketplace credit accounts...</p>
  </div>

  <section v-else-if="active_dashboard_tab === 'sales'" class="card border shadow-sm rounded overflow-hidden mb-4 bg-light">
    <div class="p-3 p-lg-4 border-bottom">
      <div>
        <h5 class="fw-bold text-dark mb-1">Sales Activity</h5>
        <div class="text-muted small">
          Showing {{ sales_page_start }}-{{ sales_page_end }} of {{ filtered_sales_orders.length }} sales for {{ sales_active_month_label }}
        </div>
      </div>
    </div>

    <div v-if="filtered_sales_orders.length" class="d-lg-none p-2">
      <div class="d-flex flex-column gap-3">
        <div
          v-for="order in paginated_sales_orders"
          :key="'sales-mobile-' + order.id"
          class="card border shadow-sm rounded bg-white"
        >
          <div class="card-body p-3">
            <button
              type="button"
              class="btn w-100 p-0 text-start border-0 bg-transparent shadow-none"
              @click="toggle_sales_order(order)"
            >
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="min-w-0">
                  <div class="fw-bold text-dark">{{ order?.order_number || order?.id }}</div>
                  <div class="text-muted small mt-1">{{ order?.buyer_name || "Unknown Customer" }}</div>
                  <div class="text-muted small">{{ format_short_date(order?.created_at) }}</div>
                </div>
                <div class="text-end flex-shrink-0">
                  <div class="fw-bold text-dark">R{{ format_price(order?.total_amount) }}</div>
                  <div class="small" :class="is_credit_order(order) ? 'text-warning-emphasis' : 'text-success'">
                    {{ get_order_payment_label(order) }}
                  </div>
                  <div class="text-muted small mt-2">
                    <i
                      class="bi"
                      :class="is_sales_order_expanded(order) ? 'bi-chevron-up' : 'bi-chevron-down'"
                    ></i>
                  </div>
                </div>
              </div>
            </button>

            <div v-if="is_sales_order_expanded(order)" class="border-top pt-3 mt-3">
              <div class="d-flex flex-column gap-3">
                <div class="d-flex align-items-center justify-content-between gap-3">
                  <div class="text-muted text-uppercase small fw-semibold">Items</div>
                  <div class="fw-semibold text-dark text-end">{{ get_order_products_label(order) }}</div>
                </div>
                <div class="d-flex align-items-center justify-content-between gap-3">
                  <div class="text-muted text-uppercase small fw-semibold">Delivery</div>
                  <div class="fw-semibold text-dark text-end">{{ get_order_delivery_label(order) }}</div>
                </div>
                <div class="d-flex align-items-center justify-content-between gap-3">
                  <div class="text-muted text-uppercase small fw-semibold">Status</div>
                  <div class="fw-semibold text-end" :class="is_order_paid(order) ? 'text-success' : 'text-warning-emphasis'">
                    {{ format_status_label(get_order_status(order) || "pending") }}
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-between gap-3">
                  <div class="text-muted text-uppercase small fw-semibold">Payment Type</div>
                  <div class="fw-semibold text-dark text-end">{{ get_order_payment_label(order) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="filtered_sales_orders.length" class="table-responsive px-3 px-lg-4 py-3 d-none d-lg-block">
      <table class="table align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th class="small text-uppercase text-muted fw-semibold py-3">Order ID</th>
            <th class="small text-uppercase text-muted fw-semibold py-3">Date</th>
            <th class="small text-uppercase text-muted fw-semibold py-3">Customer</th>
            <th class="small text-uppercase text-muted fw-semibold py-3">Items</th>
            <th class="small text-uppercase text-muted fw-semibold py-3">Amount</th>
            <th class="small text-uppercase text-muted fw-semibold py-3">Payment</th>
            <th class="small text-uppercase text-muted fw-semibold py-3">Status</th>
            <th class="small text-uppercase text-muted fw-semibold py-3">Delivery</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in paginated_sales_orders" :key="order.id">
            <td class="py-3 fw-bold text-dark">{{ order?.order_number || order?.id }}</td>
            <td class="py-3 text-muted small">{{ format_short_date(order?.created_at) }}</td>
            <td class="py-3 fw-semibold text-dark">{{ order?.buyer_name || "Unknown Customer" }}</td>
            <td class="py-3 text-dark">{{ get_order_products_label(order) }}</td>
            <td class="py-3 fw-bold text-dark">R{{ format_price(order?.total_amount) }}</td>
            <td class="py-3">
              <span class="fw-semibold" :class="is_credit_order(order) ? 'text-warning-emphasis' : 'text-success'">
                {{ get_order_payment_label(order) }}
              </span>
            </td>
            <td class="py-3">
              <span class="fw-semibold" :class="is_order_paid(order) ? 'text-success' : 'text-warning-emphasis'">
                {{ format_status_label(get_order_status(order) || "pending") }}
              </span>
            </td>
            <td class="py-3 text-dark">{{ get_order_delivery_label(order) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="filtered_sales_orders.length" class="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-2 p-3 border-top bg-light">
      <div class="text-muted small">
        Page {{ sales_page }} of {{ sales_total_pages }}
      </div>
      <div class="d-flex gap-2">
        <button
          class="btn btn-sm btn-primary rounded px-3"
          :disabled="sales_page === 1"
          @click="previous_sales_page"
        >
          Previous
        </button>
        <button
          class="btn btn-sm btn-primary rounded px-3"
          :disabled="sales_page === sales_total_pages"
          @click="next_sales_page"
        >
          Next
        </button>
      </div>
    </div>

    <div v-else class="p-4 text-center border-top">
      <i class="bi bi-search text-muted fs-4"></i>
      <p class="text-muted mb-0 mt-2">No sales matched your filters for {{ active_month_label }}.</p>
    </div>
  </section>

  <section v-else-if="selected_customer" class="card border shadow-sm rounded p-3 p-lg-4 mb-4 bg-light">
    <div class="d-flex flex-column flex-md-row align-items-md-center gap-2 mb-4">
      <div>
        <h5 class="fw-bold text-dark mb-0 fs-6 fs-md-5">{{ selected_customer.buyer_name }}</h5>
      </div>
    </div>

    <div class="row g-2 g-lg-3 mb-4">
      <div class="col-6 col-md-6">
        <div class="card border shadow-sm rounded bg-primary text-white h-100 d-lg-none">
          <div class="card-body p-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="text-white small fw-semibold text-uppercase">Not Settled Balance</div>
              <span class="text-white d-inline-flex align-items-center justify-content-center">
                <i class="bi bi-exclamation-circle"></i>
              </span>
            </div>
            <div class="fs-5 fw-bold text-white">R{{ format_price(selected_customer.outstanding_amount) }}</div>
            <div class="text-white-50 small mt-1">{{ selected_customer_unpaid_orders.length }} not settled credit orders</div>
          </div>
        </div>
        <div class="card border-1 border-primary shadow-sm rounded bg-light text-dark h-100 d-none d-lg-block">
          <div class="card-body p-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="text-muted small fw-semibold text-uppercase">Not Settled Balance</div>
              <span class="text-dark d-inline-flex align-items-center justify-content-center">
                <i class="bi bi-exclamation-circle"></i>
              </span>
            </div>
            <div class="fs-5 fw-bold text-danger">R{{ format_price(selected_customer.outstanding_amount) }}</div>
            <div class="text-muted small mt-1">{{ selected_customer_unpaid_orders.length }} not settled credit orders</div>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-6">
        <div class="card border shadow-sm rounded bg-primary text-white h-100 d-lg-none">
          <div class="card-body p-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="text-white small fw-semibold text-uppercase">Settled Balance</div>
              <span class="text-white d-inline-flex align-items-center justify-content-center">
                <i class="bi bi-check2-circle"></i>
              </span>
            </div>
            <div class="fs-5 fw-bold text-white">R{{ format_price(selected_customer.paid_amount) }}</div>
            <div class="text-white-50 small mt-1">{{ selected_customer_paid_orders.length }} settled credit orders</div>
          </div>
        </div>
        <div class="card border-1 border-primary shadow-sm rounded bg-light text-dark h-100 d-none d-lg-block">
          <div class="card-body p-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="text-muted small fw-semibold text-uppercase">Settled Balance</div>
              <span class="text-dark d-inline-flex align-items-center justify-content-center">
                <i class="bi bi-check2-circle"></i>
              </span>
            </div>
            <div class="fs-5 fw-bold text-success">R{{ format_price(selected_customer.paid_amount) }}</div>
            <div class="text-muted small mt-1">{{ selected_customer_paid_orders.length }} settled credit orders</div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3 mb-3">
      <div>
        <h5 class="fw-bold text-dark mb-1">Credit Order Activity</h5>
        <div class="text-muted small">Detailed transactions for {{ active_month_label }}</div>
      </div>
    </div>

    <div class="card border shadow-sm rounded bg-white mb-4">
      <div class="d-lg-none p-2">
        <div class="d-flex flex-column gap-3">
          <div
            v-for="order in selected_customer_orders"
          :key="'mobile-' + order.id"
            class="border rounded bg-light p-3"
          >
            <div class="d-flex align-items-start justify-content-between gap-3 mb-2">
              <div>
                <div class="fw-bold text-dark">{{ order?.order_number || order?.id }}</div>
                <div class="text-muted small">{{ format_short_date(order?.created_at) }}</div>
              </div>
              <div
                class="fw-semibold small text-end"
                :class="is_order_paid(order) ? 'text-success' : 'text-danger'"
              >
                {{ is_order_paid(order) ? "Settled" : "Not Settled" }}
              </div>
            </div>

            <div class="d-flex align-items-center justify-content-between gap-3 py-2 border-top">
              <div class="text-muted text-uppercase small fw-semibold">Product</div>
              <div class="fw-semibold text-dark text-end">{{ get_order_products_label(order) }}</div>
            </div>

            <div class="d-flex align-items-center justify-content-between gap-3 py-2 border-top">
              <div class="text-muted text-uppercase small fw-semibold">Amount</div>
              <div class="fw-bold text-dark text-end">R{{ format_price(order?.total_amount) }}</div>
            </div>

            <div class="pt-3 border-top mt-2">
              <div v-if="!is_order_paid(order)" class="d-grid">
                <button
                  class="btn btn-sm btn-primary rounded py-1"
                  :disabled="order.is_loading"
                  @click="mark_order_paid(order)"
                >
                  {{ order.is_loading ? 'Loading...' : 'Settle Credit' }}
                </button>
              </div>
              <div v-else class="d-flex justify-content-end">
                <button class="btn btn-sm btn-light border rounded px-3" disabled>
                  Settled
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="table-responsive px-3 px-lg-4 py-3 d-none d-lg-block">
      <table class="table align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th class="small text-uppercase text-muted fw-semibold py-3">Order ID</th>
            <th class="small text-uppercase text-muted fw-semibold py-3">Date</th>
            <th class="small text-uppercase text-muted fw-semibold py-3">Product</th>
            <th class="small text-uppercase text-muted fw-semibold py-3">Amount</th>
            <th class="small text-uppercase text-muted fw-semibold py-3">Status</th>
            <th class="small text-uppercase text-muted fw-semibold py-3 text-end">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in selected_customer_orders" :key="order.id">
            <td class="py-3">
              <div class="fw-bold text-dark">{{ order?.order_number || order?.id }}</div>
            </td>
            <td class="py-3 text-muted small">{{ format_short_date(order?.created_at) }}</td>
            <td>
              <div class="fw-semibold text-dark">{{ get_order_products_label(order) }}</div>
            </td>
            <td class="fw-bold py-3">R{{ format_price(order?.total_amount) }}</td>
            <td>
              <span
                class="fw-semibold"
                :class="is_order_paid(order) ? 'text-success' : 'text-danger'"
              >
                {{ is_order_paid(order) ? "Settled" : "Not Settled" }}
              </span>
            </td>
            <td class="text-end py-3">
              <button
                v-if="!is_order_paid(order)"
                class="btn btn-sm btn-primary rounded px-3"
                :disabled="order.is_loading"
                @click="mark_order_paid(order)"
              >
                {{ order.is_loading ? 'Loading...' : 'Settle Credit' }}
              </button>
              <button v-else class="btn btn-sm btn-light border rounded px-3" disabled>
                Settled
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>

    <div v-if="selected_customer_unpaid_orders.length" class="d-grid d-sm-flex justify-content-sm-end">
      <button
        class="btn btn-primary rounded px-3 px-sm-4 py-2 fw-bold text-wrap"
        :disabled="is_loading"
        @click="mark_all_customer_orders_paid"
      >
        <span v-if="is_loading">Loading...</span>
        <span v-else>
          Settle R{{ format_price(selected_customer_unpaid_total) }} for {{ selected_customer_unpaid_orders.length }} orders
        </span>
      </button>
    </div>
  </section>

  <section v-else-if="credit_orders.length" class="card border shadow-sm rounded overflow-hidden mb-4 bg-light">
    <div class="p-3 p-lg-4 border-bottom">
      <div class="d-none d-lg-block">
        <div>
          <h6 class="fw-bold text-dark mb-1">Customers on Credit</h6>
          <div class="text-muted small">
            Showing {{ customer_page_start }}-{{ customer_page_end }} of {{ customer_accounts.length }} customers for {{ active_month_label }}
          </div>
        </div>
      </div>

      <div class="d-lg-none">
        <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
          <h5 class="fw-bold text-dark mb-0">Customers</h5>
        </div>

        <div class="text-muted small mb-3">
          Showing {{ customer_page_start }}-{{ customer_page_end }} of {{ customer_accounts.length }} customers
        </div>
      </div>
    </div>

    <div v-if="customer_accounts.length" class="d-lg-none p-2">
      <div class="d-flex flex-column gap-3">
        <div
          v-for="customer in paginated_customer_accounts"
          :key="'mobile-card-' + customer.id"
          class="card border shadow-sm rounded bg-white"
        >
          <div class="card-body p-3">
            <button
              type="button"
              class="btn w-100 text-start p-0 border-0 bg-transparent shadow-none"
              @click="toggle_customer_account(customer)"
            >
              <div class="d-flex align-items-center justify-content-between gap-3">
                <div class="d-flex align-items-center gap-3 min-w-0">
                  <div class="rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center fw-bold flex-shrink-0" style="width: 46px; height: 46px;">
                    {{ get_customer_initials(customer.buyer_name) }}
                  </div>
                  <div class="min-w-0">
                    <div class="fw-bold text-dark mb-0">{{ customer.buyer_name }}</div>
                  </div>
                </div>

                <div class="d-flex flex-column align-items-end gap-2 flex-shrink-0">
                  <span
                    class="badge rounded-pill px-2 py-2 fw-semibold text-wrap"
                    :class="customer_has_unpaid_orders(customer) ? 'bg-danger-subtle text-danger' : 'bg-success-subtle text-success'"
                  >
                    <span v-if="customer_has_unpaid_orders(customer)">{{ customer.unpaid_count }} Not Settled</span>
                    <span v-else>{{ customer.paid_count }} Settled</span>
                  </span>
                  <i
                    class="bi text-muted"
                    :class="is_customer_account_expanded(customer) ? 'bi-chevron-up' : 'bi-chevron-down'"
                  ></i>
                </div>
              </div>
            </button>

            <div v-if="is_customer_account_expanded(customer)" class="border-top pt-3 mt-3">
              <div class="d-flex flex-column gap-3 mb-3">
                <div class="d-flex align-items-center justify-content-between gap-3">
                  <div class="text-muted text-uppercase small fw-semibold">Outstanding</div>
                  <div class="fw-bold text-danger fs-6 text-end">R{{ format_price(customer.outstanding_amount) }}</div>
                </div>

                <div class="d-flex align-items-center justify-content-between gap-3">
                  <div class="text-muted text-uppercase small fw-semibold">Settled</div>
                  <div class="fw-bold text-success fs-6 text-end">R{{ format_price(customer.paid_amount) }}</div>
                </div>

                <div class="d-flex align-items-center justify-content-between gap-3">
                  <div class="text-muted text-uppercase small fw-semibold">Status</div>
                  <div
                    class="fw-semibold small text-end"
                    :class="customer_has_unpaid_orders(customer) ? 'text-danger' : 'text-success'"
                  >
                    <span v-if="customer_has_unpaid_orders(customer)">{{ customer.unpaid_count }} Not Settled</span>
                    <span v-else>{{ customer.paid_count }} Settled</span>
                  </div>
                </div>

                <div class="d-flex align-items-center justify-content-between gap-3">
                  <div class="text-muted text-uppercase small fw-semibold">Orders</div>
                  <div class="fw-semibold small text-dark text-end">{{ customer.order_count }}</div>
                </div>
              </div>

              <div class="border-top pt-3 d-flex justify-content-start">
                <button
                  type="button"
                  class="btn btn-link text-decoration-none text-primary fw-semibold px-0"
                  @click="select_customer(customer)"
                >
                  View Account
                  <i class="bi bi-arrow-right-short ms-1"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="customer_accounts.length" class="list-group list-group-flush d-none d-lg-block">
      <button
        v-for="customer in paginated_customer_accounts"
        :key="customer.id"
        type="button"
        class="list-group-item list-group-item-action px-3 px-lg-4 py-3 border-0 border-top text-start"
        @click="select_customer(customer)"
      >
        <div class="row g-3 align-items-center">
          <div class="col-12 col-lg-4">
              <div class="d-flex align-items-center gap-3">
                <div class="rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center fw-bold p-3 flex-shrink-0">
                  {{ get_customer_initials(customer.buyer_name) }}
                </div>
                <div class="min-w-0">
                  <div class="fw-bold text-dark">{{ customer.buyer_name }}</div>
                  <div class="text-muted small">{{ customer.order_count }} orders</div>
                </div>
              </div>
          </div>

          <div class="col-6 col-lg-2">
            <div class="text-muted text-uppercase small fw-semibold mb-1">Outstanding</div>
            <div class="fw-bold text-danger">R{{ format_price(customer.outstanding_amount) }}</div>
          </div>

          <div class="col-6 col-lg-2">
            <div class="text-muted text-uppercase small fw-semibold mb-1">Settled</div>
            <div class="fw-bold text-success">R{{ format_price(customer.paid_amount) }}</div>
          </div>

          <div class="col-12 col-lg-2">
            <div class="text-muted text-uppercase small fw-semibold mb-1">Status</div>
            <span
              class="fw-semibold"
              :class="customer_has_unpaid_orders(customer) ? 'text-danger' : 'text-success'"
            >
              <span v-if="customer_has_unpaid_orders(customer)">{{ customer.unpaid_count }} Not Settled</span>
              <span v-else>{{ customer.paid_count }} Settled</span>
            </span>
          </div>

          <div class="col-12 col-lg-2">
            <div class="d-flex justify-content-start justify-content-lg-end">
              <span class="btn btn-link text-decoration-none text-primary fw-semibold px-0">
                View Account
                <i class="bi bi-arrow-right-short ms-1"></i>
              </span>
            </div>
          </div>
        </div>
      </button>
    </div>
    <div v-if="customer_accounts.length" class="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-2 p-3 border-top bg-light">
      <div class="text-muted small">
        Page {{ customer_page }} of {{ customer_total_pages }}
      </div>
      <div class="d-flex gap-2">
        <button
          class="btn btn-sm btn-primary rounded px-3"
          :disabled="customer_page === 1"
          @click="previous_customer_page"
        >
          Previous
        </button>
        <button
          class="btn btn-sm btn-primary rounded px-3"
          :disabled="customer_page === customer_total_pages"
          @click="next_customer_page"
        >
          Next
        </button>
      </div>
    </div>
    <div v-else class="p-4 text-center border-top">
      <i class="bi bi-search text-muted fs-4"></i>
      <p class="text-muted mb-0 mt-2">No customers matched your search for {{ active_month_label }}.</p>
    </div>
  </section>

  <div v-else class="text-center py-5">
    <i class="bi bi-credit-card text-muted display-5"></i>
    <p class="text-muted mt-3 mb-0">No marketplace credit orders found for the selected period.</p>
  </div>
</div>
